import { Navigate, Route } from "react-router-dom";
import { NewProject, ProjectDetails, ListProject } from "../components";

const projectRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"list:index"} />,
    <Route path="list" element={<ListProject />} key={"list"} />,
    <Route path="list/:id" element={<ProjectDetails />} key={"list:details"} />,
    <Route path="new" element={<NewProject />} key={"new"} />,
];
export default projectRoutes;
